module.exports = __webpack_public_path__ + "img/67.7ad7d020.png";